import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";
import Amount from "@/models/Shared/Amount";
import SimulatedLendingAccountSettings from "@/models/Accounts/Shared/Toolkit/SimulatedLendingAccountSettings";

export default class UpdateSimulationRequest extends BaseInstitutionEntity {
    name: string;
    accountId: string;
    issueDate: string;
    amount: Amount;
    lendingSettings: SimulatedLendingAccountSettings = new SimulatedLendingAccountSettings();
}